import { render, staticRenderFns } from "./EditCourseSyllabus.vue?vue&type=template&id=4ee5b7e2&scoped=true&"
import script from "./EditCourseSyllabus.vue?vue&type=script&lang=js&"
export * from "./EditCourseSyllabus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee5b7e2",
  null
  
)

export default component.exports